<template>
    <div class="about-us">
        <menuBox :step="2"></menuBox>
        <div class="about-box">
            <div class="home-text">
                <div>Our Mission and Values</div>
                <p>We are committed to providing exceptional service to our clients and establishing a strong reputation in the industry. Our mission is to help our clients achieve their goals through innovation and professionalism, fostering long-term partnerships. Our values are built on integrity, quality, and customer satisfaction, creating value for clients, opportunities for employees, and contributions to society.</p>
                <div class="btn-text">Get in Touch</div>
            </div>
        </div>

        <div class="digital-box">
            <img src="../assets/about-1.png" alt="">
            <div class="digital-text">
                <div class="title">Our Strengths</div>
                <div class="progress">
                    <div class="bar">
                        <p>Instant Response</p>
                        <p>99%</p>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-colse" style="width: 99%;"></div>
                    </div>
                </div>
                <div class="progress">
                    <div class="bar">
                        <p>Customized Solutions</p>
                        <p>85%</p>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-colse" style="width: 85%;"></div>
                    </div>
                </div>
                <div class="progress">
                    <div class="bar">
                        <p>Continuous Improvement</p>
                        <p>90%</p>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-colse" style="width: 90%;"></div>
                    </div>
                </div>
                <div class="progress">
                    <div class="bar">
                        <p>Reliability</p>
                        <p>95%</p>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-colse" style="width: 95%;"></div>
                    </div>
                </div>

                <div class="btn-more">Discover More </div>
            </div>
        </div>

        <div class="specialty-box">
            <div class="text-box">
                <div class="title-box">
                    <div class="title">Our Team</div>
                </div>
                <div class="text">Our team consists of passionate, skilled, and creative individuals. We are dedicated to realizing our clients' visions through collaboration and teamwork, delivering high-quality services and solutions. </div>
            </div>
            <div class="text-box-list">
                <div class="item-box">
                    <img src="../assets/about-2.png" alt="">
                    <div>Professionalism</div>
                    <p>We possess extensive industry experience and expertise, enabling us to provide the best solutions for our clients.</p>
                </div>
                <div class="item-box">
                    <img src="../assets/about-3.png" alt="">
                    <div>Teamwork</div>
                    <p>We emphasize teamwork and collaboration, ensuring each project receives full support and resources.</p>
                </div>
                <div class="item-box">
                    <img src="../assets/about-4.png" alt="">
                    <div>Innovative Thinking</div>
                    <p>We encourage innovation and new ideas, constantly seeking better ways to solve problems and meet client needs.</p>
                </div>
            </div>
        </div>

        <div class="solution-box">
            <div class="title">Our Commitments</div>
            <div class="solution">
                <img src="../assets/about-5.png" alt="">
                <div class="question-box">
                    <div class="question">
                        <div class="ask" @click="ask_1 = !ask_1">
                            <p>Customer-Centricity: </p>
                            <img src="../assets/about-6.png" alt="">
                        </div>
                        <div v-if="ask_1" class="answer">We prioritize customer needs and strive to meet and exceed their expectations.</div>
                    </div>
                    <div class="question">
                        <div class="ask" @click="ask_2 = !ask_2">
                            <p>Quality Assurance: </p>
                            <img src="../assets/about-6.png" alt="">
                        </div>
                        <div v-if="ask_2" class="answer">We are dedicated to delivering high-quality services and products that create lasting value for our customers.</div>
                    </div>
                    <div class="question">
                        <div class="ask" @click="ask_3 = !ask_3">
                            <p>Transparent Communication: </p>
                            <img src="../assets/about-6.png" alt="">
                        </div>
                        <div v-if="ask_3" class="answer">We communicate openly and transparently with our clients, fostering mutual trust and understanding.</div>
                    </div>
                    <div class="question">
                        <div class="ask" @click="ask_4 = !ask_4">
                            <p>Continuous Improvement:</p>
                            <img src="../assets/about-6.png" alt="">
                        </div>
                        <div v-if="ask_4" class="answer">We continually pursue excellence, striving for continuous improvement and innovation to surpass customer expectations.</div>
                    </div>
                    <div class="question">
                        <div class="ask" @click="ask_5 = !ask_5">
                            <p>Social Responsibility:</p>
                            <img src="../assets/about-6.png" alt="">
                        </div>
                        <div v-if="ask_5" class="answer">We actively fulfill our corporate social responsibility, making positive contributions to society and advocating for sustainable development.</div>
                    </div>
                </div>
            </div>
        </div>

        <footerBox :step="2"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            ask_1: false,
            ask_2: false,
            ask_3: false,
            ask_4: false,
            ask_5: false,
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="less" scoped>
.about-box {
    background: url(../assets/about-us.png);
    width: 100%;
    height: 800px;
    background-size: 100% 100%;

    .home-text {
        // margin-top: 160px;
        padding-top: 160px;
        margin-left: 360px;
        width: 750px;

        div {
            font-weight: bold;
            font-size: 64px;
            color: #FFFFFF;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            color: #B8A4EC;
            margin-top: 30px;
        }

        .btn-text {
            width: 194px;
            height: 68px;
            background: #FFFFFF;
            border-radius: 20px 20px 20px 20px;
            font-weight: 400;
            font-size: 22px;
            color: #1D1628;
            line-height: 68px;
            text-align: center;
            margin-top: 80px;
        }
    }
}

.digital-box {
    padding: 167px 360px;
    display: flex;
    justify-content: space-between;

    img {
        width: 518px;
    }

    .digital-text {
        width: 610px;

        .sbtitle {
            font-weight: 500;
            font-size: 24px;
            color: #6434E0;
        }

        .title {
            font-weight: bold;
            font-size: 46px;
            color: #333333;
            margin-top: 20px;
        }

        .progress {
            .bar {
                width: 300px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-weight: bold;
                font-size: 18px;
                color: #263959;
                margin-top: 26px;
            }

            .progress-bar {
                width: 470px;
                height: 16px;
                background: #F3F2F8;
                border-radius: 80px 80px 80px 80px;

                .progress-colse {
                    height: 16px;
                    background: #5F2DDE;
                    border-radius: 80px 80px 80px 80px;
                    margin-top: 10px;
                }
            }
        }

        .btn-more {
            width: 194px;
            height: 68px;
            background: #1E1729;
            border-radius: 20px 20px 20px 20px;
            font-weight: bold;
            font-size: 22px;
            color: #FFFFFF;
            text-align: center;
            line-height: 68px;
            margin-top: 40px;
        }
    }
}

.specialty-box {
    background: url(../assets/about-7.png);
    height: 527px;
    background-size: 100% 100%;
    padding: 80px 360px;

    .text-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title-box {
            width: 600px;

            .sbtitle {
                font-weight: 500;
                font-size: 24px;
                color: #6434E0;
            }

            .title {
                font-weight: bold;
                font-size: 46px;
                color: #333333;
                margin-top: 20px;
            }
        }

        .text {
            font-weight: bold;
            font-size: 22px;
            color: #333333;
        }
    }

    .text-box-list {
        margin-top: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item-box {
            width: 308px;
            min-height: 229px;
            background: #FFFFFF;
            border-radius: 20px 20px 20px 20px;
            padding: 30px 40px;

            img {
                width: 80px;
            }

            div {
                font-weight: bold;
                font-size: 24px;
                color: #333333;
                margin-top: 20px;
            }

            p {
                font-weight: 500;
                font-size: 17px;
                color: #999999;
                margin-top: 14px;
            }
        }
    }
}

.solution-box {
    padding: 150px 360px;

    .sbtitle {
        font-weight: 500;
        font-size: 24px;
        color: #6434E0;
        text-align: center;
    }

    .title {
        font-weight: bold;
        font-size: 46px;
        color: #333333;
        text-align: center;
        margin-top: 20px;
        // width: 500px;
    }

    .solution {
        margin-top: 111px;
        display: flex;
        // align-items: center;
        justify-content: space-between;

        img {
            width: 560px;
            height: 523px;
        }

        .question-box {
            .question {
                width: 493px;
                min-height: 0px;
                border-radius: 20px 20px 20px 20px;
                border: 1px solid #333333;
                padding: 20px 30px;
                margin-top: 20px;

                .ask {
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    img {
                        width: 26px;
                        height: 26px;
                    }
                }

                .answer {
                    width: 432px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #999999;
                    margin-top: 16px;
                }
            }
        }
    }
}
</style>